var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VcitaMultiLevelMenu',{attrs:{"data-testid":"channel-selector","activator-icon":_vm.defaultChannel.icon,"items":_vm.channels},on:{"click":_vm.updateChannel}})}
var staticRenderFns = []

export { render, staticRenderFns }